import React, {useContext} from "react";
import {AuthContext} from "../../context/AuthContext";

const MarketingWrap = ({children}) => {
    const {baseUrl} = useContext(AuthContext);

    return <div>
        <div className="sl-container sl-m-auto sl-mb-21">

            <div
                className="sl-relative "
            >
                <div className="vms-inner-menu">
                    <ul id="tabs" className="nav vms-inner-ul sl-flex sl-gap-6">
                        <li>
                            <a href={`${baseUrl}/marketing/ppc`}
                               className="sl-text-sm sl-font-medium sl-text-gray-500 sl-font"
                               aria-expanded="true" data-action="ppc-view">PPC</a>
                        </li>
                        <li>
                            <a href={`${baseUrl}/marketing/ppl`}
                               className="sl-text-sm sl-font-medium sl-text-gray-500 sl-font" aria-expanded="false"
                               data-action="ppl-view">Leads</a>
                        </li>
                        <li>
                            <a href={`${baseUrl}/marketing/top-vendors`}
                               className="sl-text-sm sl-font-medium sl-text-gray-500 sl-font">Top Vendors</a>
                        </li>
                        <li>
                            <a href={`${baseUrl}/marketing/reveal-data`}
                               className="sl-text-sm sl-font-medium sl-text-gray-500 sl-font">Reveal Data</a>
                        </li>

                        <li>
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <a
                                href={`#`}
                                className="sl-text-sm sl-font-medium sl-text-gray-500 sl-font selected-item">Client
                                reviews</a>
                        </li>
                    </ul>
                </div>
                {children}
            </div>
        </div>
    </div>

}

export default MarketingWrap;